import Rollbar from 'rollbar';
import Constant from "./Constants";

const _config = {
    accessToken: '7dd5883570db46d69c06a3dac48e8620',
    reportLevel: "error",
    environment: process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : 'development',
    codeVersion: Constant.version,
    enabled: window.location.host.indexOf('localhost:3000') >= 0 ? false : true
};

const RollbarConfig = new Rollbar(_config);

export default RollbarConfig;
